<template>
    <div>
        <v-row class="mb-2 ml-1" v-if="!loadingComponent">
            <v-col cols="12" md="5">
                <validation-provider name="tipoUnimed" ref="tipoUnimed" mode="eager" rules="required" v-slot="{ errors }">
                    <autocomplete-cadu
                        :errorMessage="errors[0]"
                        :items="listaUnimeds.map((el) => el.textoExibicao)"
                        title="Unimeds"
                        v-model="unimed.nome"
                        @index="indexUnimed"
                    />
                </validation-provider>
            </v-col>
            <v-col cols="auto" class="mt-6 pl-0">
                <button-search @click="verifyCombo"/>
            </v-col>
            <v-col cols="12" md="12">
                <table-cadu
                    class="tags"
                    custom
                    :showSelect="false"
                    :showCheck="false"
                    :showFiltro="false"
                    :rows="rows"
                    :rowsHeader="rowsHeader"
                    :disabledButtons="[false, false, true]"
                    :loading="loading"
                    :texto="unimed.nome ? '+ adicionar novo apelido' : ''"
                    nameTab="tabelaTags"
                    @clickButton="clickButton"
                />
            </v-col>
        </v-row>

        <overlay-loading v-model="loadingOverlay"/>

        <component-loading v-model="loadingComponent" />

        <error-modal
          v-model="error"
          :errObj="errObj"
        />

        <ExcluirModal
            :text="'Tem certeza que deseja excluir esse apelido?'"
            :showDelete="showDelete"
            @close="showDelete = false"
            @confirmDelete="confirmDelete"
        />
    </div>
</template>

<script>
import Unimed from '@/services/Unimed'
import ListarUnimed from '@/services/Unimed/ListarUnimed'
import { ValidationProvider } from 'vee-validate'

export default {
  components: {
    ValidationProvider
  },
  data () {
    return {
      rows: [],
      rowsHeader: [
        { text: 'Tags' },
        { text: '' }
      ],
      loading: false,
      tokenBearer: localStorage.getItem('tokenBearer'),
      loadingComponent: false,
      error: false,
      errObj: {},
      unimed: {
        nome: '',
        id: ''
      },
      listaUnimeds: [],
      showDelete: false,
      tagId: '',
      loadingOverlay: false
    }
  },
  async beforeMount () {
    this.loadingUnimeds()
  },
  methods: {
    async loadingUnimeds () {
      this.loadingComponent = true
      await this.getUnimeds()
      this.loadingComponent = false
    },
    async getUnimeds () {
      let listarUnimed = new ListarUnimed(this.tokenBearer, this.$appConfig.config.API)

      try {
        let responseGet = await listarUnimed.getAll()
        this.listaUnimeds = responseGet.data
      } catch (err) {
        this.error = true
        this.errObj.status = err.response.status
        this.errObj.error = err.response.data.message
      }
    },
    async loadingTags () {
      this.loading = true
      await this.getTags()
      this.loading = false
    },
    async getTags () {
      let unimed = new Unimed(this.tokenBearer, this.$appConfig.config.API)

      try {
        let responseGet = await unimed.getTags(this.unimed.id)
        this.rows = responseGet.data
      } catch (err) {
        this.error = true
        this.errObj.status = err.response.status
        this.errObj.error = err.response.data.message
      }
    },
    async verifyCombo () {
      let res = await this.$refs.tipoUnimed.validate()
      if (res.valid) {
        this.loadingTags()
      }
    },
    async confirmDelete () {
      let unimed = new Unimed(this.tokenBearer, this.$appConfig.config.API)
      this.showDelete = false
      this.loadingOverlay = true

      try {
        await unimed.deleteTags(this.unimed.id, this.tagId)
        this.$emit('excluir')
      } catch (err) {
        this.loadingOverlay = false
        this.error = true
        this.errObj.status = err.response.status
        this.errObj.error = err.response.data.message
      } finally {
        this.loadingOverlay = false
      }
    },
    indexUnimed (index) {
      this.unimed.id = (index > -1 && index !== null) ? this.listaUnimeds[index].id : ''
    },
    clickButton (obj) {
      switch (obj.type) {
        case 'add':
          this.$emit('add', this.unimed)
          break
        case 'delete':
          this.tagId = obj.selected
          this.showDelete = true
          break
      }
      this.$emit('viewModal', this.rows[obj.index])
    }
  }
}
</script>

<style lang="sass" >
.tags > .table-cadu
    border: none
    border-radius: 0px
    width: 100% !important
    padding-bottom: 4px
    padding: 0px !important

.tags > .table-cadu > .table
  max-height: 250px
  overflow: auto
  table
    width: 100%
    tbody
        tr
            td
                &:last-child
                    text-align: center !important
</style>
